import styled from 'styled-components';

import {
  Flex,
  SVG,
} from 'web-styled';

export const Header = styled(Flex).attrs({
  flex: '0 0 70px',
  align: 'center',
  justify: 'space-between',
  spacing: 10,
})`
  width: 100%;
  padding: 0 30px;
  border-top: 1px solid rgba(40, 45, 48, 0.1);
  border-bottom: 1px solid rgba(40, 45, 48, 0.1);
  background-color: #f9f9f9;

  @media print {
    width: auto;
    padding: 0;
    background-color: #ccc;
    border-radius: 0 5px 5px 0;
    border: none;
  }
`;

export const CounterWrapper = styled(Flex)`
  @media print {
    min-width: 210px;
    padding: 15px 29px;
    margin-right: 0 !important;
  };
`;

export const Counter = styled.span`
  color: #797979;
  font-size: 31px;
  line-height: 44px;

  @media print {
    color: #000;
    &::placeholder {
      color: #000;
    }
  }
`;

export const CounterName = styled.span`
  color: #797979;
  font-size: 15px;
  text-transform: uppercase;

  @media print {
    color: #000;
  }
`;

export const PlusCircle = styled(SVG.PlusCircle).attrs(
  props => ({
    stroke: props.theme.colors.primary,
  }),
)``;

export const AddButton = styled.div`
  margin-top: 2px;
  flex-shrink: 0;
  opacity: 0.6;
`;
